import { makeStyles } from '@mui/styles'

export const paidConsumerDesktopNavHeight = 118
export const paidConsumerMobileNavHeight = 60

export const useStyles = makeStyles(({ spacing, palette }) => ({
  // Main AppBar styles
  appBar: {
    backgroundColor: palette.common.white,
    color: palette.text.primary,
    boxShadow: 'none',
    position: 'sticky',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1200
  },
  toolbar: {
    padding: '0',
    minHeight: 64,
    width: '100%'
  },
  mindsetBubble: ({ isMeteringEnabled }) => ({
    position: 'fixed',
    bottom: isMeteringEnabled ? '140px' : '20px',
    right: '20px',
    width: '63px',
    height: '63px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.primary.main,
    borderRadius: '50%',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    cursor: 'pointer'
  })
}))
